import { Module } from '@nestjs/common';
import { CompaniesService } from './companies.service';
import { CompaniesController } from './companies.controller';
import { CompanyEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';

@Module({
  controllers: [CompaniesController],
  providers: [CompaniesService],
  imports: [TypeOrmModule.forFeature([CompanyEntity])],
})
export class CompaniesModule {}
